import actionCreatorFactory from 'typescript-fsa';
import { ApiFieldError } from 'src/types';

export const actionCreator = actionCreatorFactory(
  `@manager/features/collaterals/UPDATE`
);
export type APIError = ApiFieldError;
export type UpdateCollateralParams = any;
export type CreateCollateralParams = any;
export type DeleteCollateralParams = any;
export type updateLatestCollateralParams = any;
export const describeCollateralActions = actionCreator.async<
  any,
  any,
  APIError[]
>('request-collaterals');

export const updateCollateralActions = actionCreator.async<
  UpdateCollateralParams,
  any,
  APIError[]
>(`update`);
export const createCollateralActions = actionCreator.async<
  CreateCollateralParams,
  any,
  APIError[]
>(`create`);
export const updateLatestCollateralActions = actionCreator.async<
  updateLatestCollateralParams,
  any,
  APIError[]
>(`updateLatest`);

export const deleteCollateralActions = actionCreator.async<
  DeleteCollateralParams,
  any,
  APIError[]
>(`delete`);
